/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const newDatePickerTokens = {
  ContainerBorderColorBaseDefault: '#c4c4c4',
  ContainerBorderRadiusBaseDefault: '12px',
  ContainerFontColorBaseDefault: '#1c2222',
  DaysBackgroundColorBaseDefault: 'rgba(0, 0, 0, 0)',
  DaysBackgroundColorSelectedDefault: '#2c67b5',
  DaysBackgroundColorSelectedHover: '#285da3',
  DaysBorderColorBaseDefault: 'rgba(0, 0, 0, 0)',
  DaysBorderColorBaseHover: '#c4c4c4',
  DaysBorderRadiusBaseDefault: '4px',
  DaysBorderWidthBaseDefault: '1px',
  DaysSpacingPaddingBaseDefault: '8px',
  HeaderBackgroundColorBaseDefault: 'rgba(0, 0, 0, 0)',
  HeaderSpacingPaddingBaseDefault: '12px',
  PanelButtonColorBaseDefault: '#232b2b',
  PanelButtonColorBaseHover: '#000000',
  PanelButtonBackgroundColorBaseDefault: '#ffffff',
  PanelButtonBorderColorBaseDefault: 'rgba(0, 0, 0, 0)',
  PanelButtonBorderColorBaseHover: '#c4c4c4',
  PanelButtonBorderColorBaseFocus: '#285da3',
  PanelButtonBorderRadiusBaseDefault: '4px',
  PanelButtonBorderWidthBaseDefault: '1px',
} as const;
